import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import { handlePlayAt, handleRemove, handleAddSongToQueue } from "../actions";
import { SocketStateContext } from "../../../provider";
import SongItem from "./song-item";
import { Col, Box, Text, Row, Img } from "../../../comps";
import { Theme } from "../../../theme/theme-provider";

import { queueArt } from "../../../theme/image";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
`;

const Head = styled(Row)`
  width: 94%;
  height: 30px;
  /* align-items: center; */
  border-bottom: 1px solid ${({ theme }) => theme.textColor.light};
`;

const ListWrapper = styled(Col)`
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: scroll;
  overflow-x: hidden;
  align-items: center;
  &::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0px;
  }
  &:hover {
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.color.GRAY_2};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.color.GRAY_1};
      border-radius: 20px;
    }
  }
`;

const List = styled(Box)`
  width: 94%;
`;

const Art = styled(Col)`
  width: 100%;
  height: ${({ verticallyCenter }) => (verticallyCenter ? "30vh" : "auto")};
  align-items: center;
  justify-content: ${({ verticallyCenter }) =>
    verticallyCenter ? "center" : ""};
  cursor: pointer;
`;

const ShowQueue = ({ time, queue, isPlaying, currentSongIndex }) => {
  const [socketInfo, setSocketInfo] = useContext(SocketStateContext);
  const { isJoined } = socketInfo;

  useEffect(() => {
    if (document.getElementsByClassName("sheetQueueGrid").length > 0)
      new MuuriGrid(".sheetQueueGrid", {
        dragEnabled: true,
        layout: { fillGaps: true, alignLeft: true, alignTop: true },
      });
  }, [time]);

  return (
    <List>
      <div class="grid sheetQueueGrid">
        {queue.map((song, idx) => {
          return (
            <SongItem
              key={idx}
              song={song}
              isFocused={idx === currentSongIndex}
              isPlaying={isPlaying && idx === currentSongIndex}
              showDelete={!isJoined}
              onPlay={() => {
                handlePlayAt(idx);
              }}
              onRemove={() => {
                handleRemove(idx);
              }}
            />
          );
        })}
      </div>
      <Art verticallyCenter={true} onClick={handleAddSongToQueue}>
        <Img width="30%" src={queueArt} />
        <Text
          fontSize="14px"
          fontWeight={600}
          color={Theme.color.GRAY_1}
          marginTop="-12px"
        >{`Add more songs to queue`}</Text>
      </Art>
    </List>
  );
};

export default ({ queue, isPlaying, currentSongIndex }) => {
  const isQueue = queue && queue.length > 0;

  return (
    <Wrapper>
      <Head>
        <Text
          marginLeft="10px"
          fontSize="26px"
          color={Theme.color.GRAY_0}
          fontWeight="500"
        >{`Queue`}</Text>
      </Head>
      <ListWrapper>
        {isQueue && (
          <ShowQueue
            time={new Date().getTime()}
            queue={queue}
            isPlaying={isPlaying}
            currentSongIndex={currentSongIndex}
          />
        )}
        {!isQueue && (
          <List>
            <Art verticallyCenter={!isQueue} onClick={handleAddSongToQueue}>
              <Img width="30%" src={queueArt} />
              <Text
                fontSize="14px"
                fontWeight={600}
                color={Theme.color.GRAY_1}
                marginTop="-12px"
              >{`Add ${isQueue ? "more" : "some"} songs to queue`}</Text>
            </Art>
          </List>
        )}
      </ListWrapper>
    </Wrapper>
  );
};
